/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhhess_Hochschulangehoerige27Inputs */

const en__field_enum_ikhhess_hochschulangehoerige27 = /** @type {(inputs: _Field_Enum_Ikhhess_Hochschulangehoerige27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angehörige*r einer anderen Hochschule (nicht GU)`)
};

const de__field_enum_ikhhess_hochschulangehoerige27 = /** @type {(inputs: _Field_Enum_Ikhhess_Hochschulangehoerige27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angehörige*r einer anderen Hochschule (nicht GU)`)
};

/**
* | output |
* | --- |
* | "Angehörige*r einer anderen Hochschule (nicht GU)" |
*
* @param {_Field_Enum_Ikhhess_Hochschulangehoerige27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhhess_hochschulangehoerige27 = /** @type {((inputs?: _Field_Enum_Ikhhess_Hochschulangehoerige27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhhess_Hochschulangehoerige27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhhess_hochschulangehoerige27(inputs)
	return de__field_enum_ikhhess_hochschulangehoerige27(inputs)
});
export { _field_enum_ikhhess_hochschulangehoerige27 as "_field_enum_IKHHESS_HOCHSCHULANGEHOERIGE" }